import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {Tag} from 'antd'
import {ITEMS_STATUS} from '../../../helpers/orderFilters'
import TagItem from './TagItem'
import LazyLoad from 'react-lazyload'
import {parseJwt} from '../../../../../helpers/parseToken'
import {getLocalData} from '../../../../../services/StorageServices'

class Marketplace extends Component {
    _translateProductionStatus = () => {
        const {productionStatus} = this.props
        const found = ITEMS_STATUS.find(status => status.value === productionStatus)

        if (found === undefined || found.value === '') {
            return null
        }

        return <Tag color='#6c757d'>{found.name}</Tag>
    }

    render() {
        const {marketplace, itemNumber, basketNumber, namespace, batch, packageName, tags, lazyload} = this.props
        const isSpecialTag = Array.isArray(tags) && tags.includes('priority-store')
        const orderTemplate = `${marketplace}_${itemNumber}`
        const role = parseJwt(getLocalData('accessToken')).roles || []
        const allowedRoles = ['fac_admin', 'fac_ffm']
        const canViewNamespace = role.some(item => allowedRoles.includes(item.name))

        return (
            <td className='Marketplace'>
                {
                    lazyload ? 
                    <LazyLoad>
                        <Link to={`/order-item?template=${orderTemplate}`} target='_blank'>#{orderTemplate}</Link>

                        {
                            !!packageName &&
                            <div title="orderNumber" className='orderNumber'>
                                {packageName}
                            </div>
                        }

                        {
                            !!namespace && canViewNamespace &&
                            <div title="Namespace" className='Namespace mb-1'>
                                <small>{namespace}</small>
                            </div>
                        }

                        {
                            !!basketNumber &&
                            <div title="Số giỏ" className='mb-1'>
                                <code>{basketNumber}</code>
                            </div>
                        }

                        {this._translateProductionStatus()}

                        {
                            !!batch &&
                            <div title="Tên lô" className="BatchInfo">
                                <span><Link to={`/batches/${batch.id}`}>{batch.name}</Link></span>
                            </div>
                        }
                        {
                            isSpecialTag && <Tag color="#ff0000">Đặc biệt</Tag>
                        }

                        {
                            tags && tags.length > 0 &&
                            tags.map(tag => {
                                return <TagItem tag={tag}/>
                            })
                        }
                    </LazyLoad> : 
                    <>
                        <Link to={`/order-item?template=${orderTemplate}`} target='_blank'>#{orderTemplate}</Link>

                        {
                            !!packageName &&
                            <div title="orderNumber" className='orderNumber'>
                                {packageName}
                            </div>
                        }

                        {
                            !!namespace && canViewNamespace &&
                            <div title="Namespace" className='Namespace mb-1'>
                                <small>{namespace}</small>
                            </div>
                        }

                        {
                            !!basketNumber &&
                            <div title="Số giỏ" className='mb-1'>
                                <code>{basketNumber}</code>
                            </div>
                        }

                        {this._translateProductionStatus()}

                        {
                            !!batch &&
                            <div title="Tên lô" className="BatchInfo">
                                <span><Link to={`/batches/${batch.id}`}>{batch.name}</Link></span>
                            </div>
                        }
                        {
                            isSpecialTag && <Tag color="#ff0000">Đặc biệt</Tag>
                        }

                        {
                            tags && tags.length > 0 &&
                            tags.map((tag, index) => {
                                return <TagItem key={index} tag={tag}/>
                            })
                        }
                    </>
                }
            </td>
        )
    }
}

Marketplace.propTypes = {
    batch: PropTypes.object,
    namespace: PropTypes.string,
    basketNumber: PropTypes.string,
    marketplace: PropTypes.string.isRequired,
    itemNumber: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
    size: PropTypes.string.isRequired,
    productionStatus: PropTypes.string.isRequired,
    packageName: PropTypes.string,
    tags: PropTypes.array
}

export default Marketplace
